<template>
	<BottomSheet name="cart-updated" title="Bag updated">
		<p class="pt-4 text-base font-medium text-muted">Some items in your bag changed because of stock updates.</p>

		<section v-if="oosItems.length" class="pt-5">
			<h3 class="section-label !px-0">Removed — out of stock</h3>
			<ul class="space-y-3">
				<li v-for="line in oosItems" :key="line.item?.id || line.variant?.id" class="flex items-center gap-3">
					<span class="well h-14 w-14 flex-none p-1"><img :src="thumb(line.item)" alt="" /></span>
					<span class="min-w-0 flex-1 font-semibold"
						>{{ line.item?.name || 'Item' }} <span class="text-muted">· Qty {{ line.quantity }}</span></span
					>
				</li>
			</ul>
		</section>

		<section v-if="lowStockItems.length" class="pt-5">
			<h3 class="section-label !px-0">Quantity lowered</h3>
			<ul class="space-y-3">
				<li v-for="line in lowStockItems" :key="line.item?.id || line.variant?.id" class="flex items-center gap-3">
					<span class="well h-14 w-14 flex-none p-1"><img :src="thumb(line.item)" alt="" /></span>
					<span class="min-w-0 flex-1">
						<span class="block font-semibold">{{ line.item?.name || 'Item' }}</span>
						<span class="block text-sm text-muted">Now {{ line.newQuantity ?? line.availableQuantity ?? line.quantity }} in your bag</span>
					</span>
				</li>
			</ul>
		</section>

		<section v-if="invalidItems.length" class="pb-2 pt-5">
			<h3 class="section-label !px-0">Options no longer available</h3>
			<ul class="space-y-3">
				<li v-for="line in invalidItems" :key="line.variant?.id || line.product?.id" class="flex items-center gap-3">
					<span class="well h-14 w-14 flex-none p-1"><img :src="thumb(line.product)" alt="" /></span>
					<span class="min-w-0 flex-1">
						<router-link :to="productLink(line.product)" class="block font-semibold text-link underline">{{ line.product?.name || 'Item' }}</router-link>
						<span class="block text-sm text-muted">Pick an available option on the product page to add it again.</span>
					</span>
				</li>
			</ul>
		</section>

		<template #footer>
			<button type="button" class="btn" @click="close">OK</button>
		</template>
	</BottomSheet>
</template>

<script>
import BottomSheet from './BottomSheet.vue'
import { closeSheet } from '@/lib/sheets'
import { productThumb, productUrl } from '@/lib/products'

// Phone version of front/src/components/layout/cart-validation.vue.
export default {
	components: { BottomSheet },
	props: {
		oosItems: { type: Array, default: () => [] },
		lowStockItems: { type: Array, default: () => [] },
		invalidItems: { type: Array, default: () => [] },
	},
	methods: {
		thumb: productThumb,
		productLink(product) {
			return product ? productUrl(product) : '/cart'
		},
		close() {
			closeSheet('cart-updated')
		},
	},
}
</script>
